import { render, staticRenderFns } from "./ModalExitSimulation.vue?vue&type=template&id=53c50d2e"
import script from "./ModalExitSimulation.vue?vue&type=script&lang=ts"
export * from "./ModalExitSimulation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports